import { Tooltip } from "@mui/material";
import { FC } from "react";
import { BoldTypography, StatusTypography, TooltipBackground } from "./CustomTooltip.styles";
import { ICustomTooltip } from "./CustomTooltip.props";
import { useTranslate } from "@/hooks";

const CustomTooltip: FC<ICustomTooltip> = ({ title, children, ...props }) => {
	const translate = useTranslate();

	return (
		<Tooltip
			title={
				<TooltipBackground>
					<StatusTypography variant="body2">
						{title.map((el) =>
							Object.entries(el).map(([key, value]) => (
								<>
									<BoldTypography>{`${translate(key)}`}</BoldTypography> {value}
								</>
							))
						)}
					</StatusTypography>
				</TooltipBackground>
			}
			arrow
			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: "#ffffff",
						boxShadow: 1,
					},
				},
				arrow: {
					sx: {
						color: "#ffffff",
					},
				},
			}}
			{...props}
		>
			{children}
		</Tooltip>
	);
};

export default CustomTooltip;
